export default __webpack_public_path__ + "static/Montserrat-italic-7583622cfde30ae49086d18447ab28e7.woff";